<template>
  <div class="auth-wrapper">
    <img src="@/assets/logo-CorWfPtl.png" alt="Logo" class="auth-logo" />

    <div class="auth-container">
      <h2>Ustaw nowe hasło</h2>

      <form @submit.prevent="handleResetPassword">
        <div class="form-group">
          <label for="email">Email</label>
          <input v-model="email" id="email" type="email" required />
        </div>

        <div class="form-group">
          <label for="password">Nowe hasło</label>
          <input v-model="password" id="password" type="password" required />
        </div>

        <div class="form-group">
          <label for="password_confirmation">Potwierdź hasło</label>
          <input v-model="password_confirmation" id="password_confirmation" type="password" required />
        </div>

        <div v-if="message" class="success-message">
          {{ message }}
        </div>

        <div v-if="error" class="error-message">
          {{ error }}
        </div>

        <button type="submit" class="login-button" :disabled="loading">
          {{ loading ? 'Zapisywanie...' : 'Zmień hasło' }}
        </button>

        <div class="links">
          <router-link to="/cms/login">Wróć do logowania</router-link>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import api from '@/services/apiService'

export default {
  name: 'ResetPassword',
  data() {
    return {
      email: '',
      password: '',
      password_confirmation: '',
      token: '',
      loading: false,
      message: null,
      error: null
    }
  },
  mounted() {
    this.token = this.$route.query.token || this.$route.params.token
    this.email = this.$route.query.email || ''
  },
  methods: {
    async handleResetPassword() {
      this.loading = true
      this.message = null
      this.error = null

      if (this.password.length < 8) {
          this.error = 'Hasło musi mieć co najmniej 8 znaków.'
          this.loading = false
          return
      }
      if (!/[^A-Za-z0-9]/.test(this.password)) {
          this.error = 'Hasło musi zawierać co najmniej jeden znak specjalny (np. !@#$%).'
          this.loading = false
          return
      }
      if (this.password !== this.password_confirmation) {
          this.error = 'Hasła nie są identyczne.'
          this.loading = false
          return
      }

      try {
        await api.auth.csrf()
        const response = await api.auth.resetPassword({
          token: this.token,
          email: this.email,
          password: this.password,
          password_confirmation: this.password_confirmation
        })
        this.message = response.data.status || 'Hasło zostało zmienione.'
        setTimeout(() => {
          this.$router.push('/cms/login')
        }, 2000)
      } catch (err) {
        console.error('Błąd zmiany hasła:', err)
        this.error = 'Wystąpił błąd. Spróbuj ponownie.'
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
.auth-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background-color: $color-grey-light;
  padding: 2rem;
}

.auth-logo {
  max-width: 250px;
  margin-bottom: 3rem;
}

.auth-container {
  max-width: 400px;
  width: 100%;
  background-color: $color-white;
  padding: 2rem 2.5rem;
  border-radius: 12px;
  box-shadow: 0 0 20px $color-shadow;
  font-family: 'Inter', sans-serif;
  color: $color-text;
}

h2 {
  text-align: center;
  margin-bottom: 2rem;
  color: $color-primary-dark;
}

.form-group {
  margin-bottom: 1.5rem;

  label {
    display: block;
    margin-bottom: 0.5rem;
    font-weight: 500;
  }

  input {
    width: 100%;
    padding: 0.75rem;
    border: 1px solid $color-grey;
    border-radius: 6px;
    font-size: 1rem;
    transition: border-color 0.2s;

    &:focus {
      outline: none;
      border-color: $color-primary;
    }
  }
}

.login-button {
  width: 100%;
  padding: 0.75rem;
  background-color: $color-primary;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: $color-primary-dark;
  }

  &:disabled {
    background-color: lighten($color-primary, 20%);
    cursor: not-allowed;
  }
}

.success-message {
  background-color: #d4edda;
  color: #155724;
  padding: 0.75rem;
  border-radius: 6px;
  margin-bottom: 1rem;
  text-align: center;
}

.error-message {
  background-color: #f8d7da;
  color: #721c24;
  padding: 0.75rem;
  border-radius: 6px;
  margin-bottom: 1rem;
  text-align: center;
}

.links {
  margin-top: 1.5rem;
  text-align: center;
  
  a {
    color: $color-primary;
    text-decoration: none;
    font-size: 0.9rem;
    
    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
